import { Model } from 'modules/core/lib/mobx-rest'

export interface ICompanyInstallation {
  author_id: string
  form_data: string
  integration_id: string
  company_id: string
  access_id: string
}

class CompanyInstallation extends Model<ICompanyInstallation> {
  static urlRoot() {
    return '/api/rest/marketplace/company_installation'
  }
}

export default CompanyInstallation
